<!--
TELA PARA INCLUSÃO/ALTERAÇÃO DE ITEM NA NOTA DE SAIDA
-->


<script>
import { SysVars } from '../main';
import nfItem from '../api/api-nf-item.js'
import ItemForm from './item-form'

export default {
  props: {
    params: {},  //nfit: objeto, optSimples: false, nfAjuste: false, nfComplemento: false, habilitaItem: true
  },

  components: {
    ItemForm,
  },

  data() {
    return {
      nfit: {},
      //metadata: this.$store.getters.getEntities.metadata,
      local_metadata: { ...this.$store.getters.getEntities.metadata.nfit },
      tributadoIcm: false,
      informaMotdes: false,
      icmDiferido: false,
      tributadoPis: false, //habilita pis
      informaFCI: false,   //habilita nr do fci conforme origem da mercadoria
      pautaPis: false,
      tributadoCofins: false,
      pautaCofins: false,
      tributadoPisST: false,
      tributadoCofinsST: false,
      creditoSN: false,   //habilita % credito icms simples nacional
      unWatch: false,
      descricaoNovoItem: '',

      errmessages: [],
      crud: '',
      showItemForm: false
    }
  },

  mixins: [nfItem],

  computed: {
    isView: function () {
      return this.params.isView == true
    },
    coditem: function () {
      return this.nfit.coditem
    },
    selectedItem: function () {
      return this.$store.getters.getItem
    },
    itemTaxes: function () {
      return this.$store.getters.getItemTaxes
    },
    sticm() {
      return this.nfit.sticm
    },
    stipi() {
      return this.nfit.stipi
    },
    stpis() {
      return this.nfit.stpis
    },
    stcofins() {
      return this.nfit.stcofins
    },
    csosn() {
      return this.nfit.csosn
    },
    sticmentrada() {
      return this.nfit.sticmentrada
    },
    orimerc() {
      return this.nfit.orimerc
    },
    nfImportacao: function () {
      return (this.params.nfImportacao)
    },

    // tributadoIcmST () {
    //     return (this.nfit.sticm == '10' || this.nfit.sticm == '30' || this.nfit.sticm == '70' || this.nfit.sticm == '90')
    // }

  },

  methods: {

    handleCadastroItem(text) {
      //abre tela para cadastro de novo produto
      this.crud = SysVars.crudI
      this.descricaoNovoItem = text
      this.showItemForm = true
    },

    closeItemForm(item) {
      //ao fechar o formulario de cadastro de produto
      this.showItemForm = false
      if (item) {
        this.nfit.coditem = item.coditem
      }
    },

    handleNewItem(selectedItem) {
      if (!selectedItem) return
      this.nfit.coditem = selectedItem.coditem
    },

    handleSalvar() {
      //botao salvar item
      var param = []
      param.push(this.nfit)
      this.$emit('save', param)
    },

    closeForm() {
      this.$emit('closeform')
    },

    handleValidation() {
      this.errmessages = []

      this.$validator.reset();

      //VALIDACAO DOS CAMPOS DE IMPOSTOS CONFORME SITUACAO TRIBUTARIA DE CADA IMPOSTO
      this.local_metadata.aicm.validator = {}
      this.local_metadata.ricm.validator = {}
      this.local_metadata.aicmst.validator = {}
      this.local_metadata.bcicm.validator = {}
      this.local_metadata.vicm.validator = {}
      this.local_metadata.bcicmst.validator = {}
      this.local_metadata.vicm.validator = {}
      this.local_metadata.aipi.validator = {}
      this.local_metadata.ripi.validator = {}
      this.local_metadata.vipi.validator = {}
      this.local_metadata.bcipi.validator = {}
      this.local_metadata.apis.validator = {}
      this.local_metadata.rpis.validator = {}
      this.local_metadata.apisst.validator = {}
      this.local_metadata.vpis.validator = {}
      this.local_metadata.bcpis.validator = {}
      this.local_metadata.acofins.validator = {}
      this.local_metadata.rcofins.validator = {}
      this.local_metadata.acofinsst.validator = {}
      this.local_metadata.vcofins.validator = {}
      this.local_metadata.bccofins.validator = {}

      if (this.params.nfAjuste || this.params.nfComplementar) {
        this.local_metadata.ncm.validator = {}
      }

      if (this.tributadoPis) {
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.apis.validator = { required: true, "valida-zero": true }
          this.local_metadata.bcpis.validator = { required: true, "valida-zero": true }
          this.local_metadata.vpis.validator = { required: true, "valida-zero": true }
        }
      }

      if (this.tributadoCofins) {
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.acofins.validator = { required: true, "valida-zero": true }
          this.local_metadata.bccofins.validator = { required: true, "valida-zero": true }
          this.local_metadata.vcofins.validator = { required: true, "valida-zero": true }
        }
      }


    },

    handleValidarItem() {
      if (this.nfit.vlr == 0) {
        this.$erpToastError('Insira o valor do item')
        return;
      }

      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.handleSalvar()
        }
      })

    },
  },

  watch: {
    'nfit.stpis': function () {
      this.handleValidation()
    },
    'nfit.stcofins': function () {
      this.handleValidation()
    },

    'nfit.coditem': function () {
      //ao digitar um item, carrega os dados deste item
      if (this.unWatch) {
        this.unWatch = false
        return
      }


      if (this.coditem != null) {
        this.nfit.coditem = this.coditem
        this.nfit.operacaonf = this.params.nf.operacaonf
        this.nfit.qt = 1;
        this.nfit.qtuni = 1;

        this.apiCarregaProduto(this.nfit)

        this.handleValidation()
      }
    },

    selectedItem: function () {
      //quando selecionar um item, carrega a unidade de medida, ncm e a origem da mercadoria
      if (this.unWatch) return

      if (!this.selectedItem.length) {
        return
      }
    },

    itemTaxes: function () {
      //ao selecionar um item, carrega a os dados de impostos deste item
      if (this.unWatch) return

      if (!this.itemTaxes) {
        return
      }
    },

    csosn: function () {
    },

    sticmentrada: function () {
    },

    sticm: function () {
    },

    stipi: function () {
    },

    stpis: function () {
      this.tributadoPis = (this.nfit.stpis == '01' || this.nfit.stpis == '02' || this.nfit.stpis == '49' ||
        this.nfit.stpis == '50' || this.nfit.stpis == '98' || this.nfit.stpis == '99')
      this.tributadoPisST = (this.nfit.stpis == '05')
      this.pautaPis = (this.nfit.stpis == '03')
    },

    stcofins: function () {
      this.tributadoCofins = (this.nfit.stcofins == '01' || this.nfit.stcofins == '02' || this.nfit.stcofins == '49' ||
        this.nfit.stcofins == '50' || this.nfit.stcofins == '98' || this.nfit.stcofins == '99')
      this.tributadoCofinsST = (this.nfit.stcofins == '05')
      this.pautaCofins = (this.nfit.stcofins == '03')
    },

    orimerc: function () {
      this.informaFCI = (this.nfit.orimerc == '1' || this.nfit.orimerc == '2' || this.nfit.orimerc == '3' || this.nfit.orimerc == '8')
    },

    'params.ipidevol': function () {
    },

    'nfit.qtuni': function () {
    }

  },

  mounted() {
  },

  created() {
    if (this.params.nfit) {
      this.nfit = this.params.nfit
    }
    this.unWatch = true

    this.$nextTick(function () {
      if (this.$refs.item)
        this.$refs.item.focus()
    })

  }

}

</script>

<template>
  <transition>
    <div>
      <div class="nb-modal-scrollable" v-if="!showItemForm">
        <div class="container nb-modal-scrollable-container">
          <div class="nb-modal-header">
            <h4 class="def-title"> Item da Nota Fiscal</h4>
            <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div id="mymodal" class="nb-modal-scrollable-body" @keydown.f9="handleValidarItem">
            <div class="row" v-if="!params.habilitaItem">
              <div class="col-md-3 col-1">
                <span class="lbl-title-produto w-100">{{ nfit.item[0].descricao }}</span>
                <span class="data-list w-100">{{ nfit.item[0].codigo }}</span>
              </div>
              <div class="col-md-2 col-5" align="right">
                <span class="lbl-title-produto w-100">{{ this.local_metadata.totliq.label }}</span>
                <span class="data-list w-100">{{ this.nfit.totliq | formatValue(2) }}</span>
              </div>
            </div>

            <!-- permite informar dados do item para notas de remessa, devolução, retorno, transferencia -->
            <div id="item" v-if="params.habilitaItem">
              <div class="row">
                <div class="col-md-12 col-12">
                  <v-label class="w-100" :metadata-field="local_metadata.coditem"></v-label>
                  <div class="">
                    <input-item ref="item" v-model="nfit.coditem" :add-button="true" @onselect="handleNewItem"
                      :disabled="nfit.codpedv" :tipoitem="'S'" @novo="handleCadastroItem"></input-item>
                  </div>
                </div>
                <!-- <form-field v-model="nfit.coditem" type="select2" col="12" :metadata="local_metadata.coditem" :disabled="isView"
                          name="coditem" :v-errors="errors" v-validate="local_metadata.coditem.validator"></form-field> -->
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <v-label :metadata-field="local_metadata.obs"></v-label>
                    <textarea rows="4" cols="100" class="form-control form-control-sm" :disabled="isView" name="desccomp"
                      v-model="nfit.obs" v-validate="{}"></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <form-field v-model="nfit.vlr" type="value" col="4" :metadata="local_metadata.vlr"
                  :disabled="isView || nfit.codpedv" name="vlr" :v-errors="errors"
                  v-validate="local_metadata.vlr.validator"></form-field>
                <form-field v-model="nfit.totliq" type="value" col="4" :metadata="local_metadata.totliq"
                  :disabled="isView" name="totliq" :v-errors="errors" v-validate="local_metadata.totliq.validator"
                  v-if="params.nfComplementar"></form-field>
              </div>
            </div>
            <div class="nb-modal-scrollable-footer">
              <v-button v-if="!isView" ref="btnConfirm" label="Salvar (F9)" title="" :nb-btdef="true"
                @click="handleValidarItem"></v-button>
              <v-button ref="btnClose" label="Cancelar" title="" @click="closeForm"></v-button>
            </div>
          </div>
        </div>
      </div>

      <div class="nb-modal-scrollable" v-if="showItemForm">
        <Trap>
          <div class="container nb-modal-scrollable-container">
            <div class="nb-modal-scrollable-body">
              <item-form :crud="crud" :descricao="descricaoNovoItem" @closeform="closeItemForm"></item-form>
            </div>
          </div>
        </Trap>
      </div>
    </div>
  </transition>
</template>

<style></style>



// WEBPACK FOOTER //
// src/forms/nfse-item.vue